import React from "react";
import { useState, useEffect } from "react";
import { Col, Row, Container, Card, Accordion, Form } from 'react-bootstrap';
import { useLocation, useNavigate } from "react-router-dom";
import Chart from 'react-apexcharts';
import axios from "axios";
import "./landingpage.css"
import Typewriter from 'typewriter-effect';
import CountUp from 'react-countup'
import defaultImage from './../assets/default_category_image.jpg'
import { Helmet } from "react-helmet-async";


function CategoryLandingPage(plan) {

    const [categoryDetails, setCategoryDetails] = useState([]);
    const [siteOptions, setSiteOptions] = useState(initBarOptions(0, []));
    const [siteSeries, setSiteSeries] = useState(initBarSeries([]));
    const [socialOptions, setSocialOptions] = useState(initBarOptions(0, []));
    const [socialSeries, setSocialSeries] = useState(initBarSeries([]));
    const [treemapOptions, setTreemapOptions] = useState(initTreemapOptions([]));
    const [treemapSeries, setTreemapSeries] = useState(initTreemapSeries([]));
    const [barOptions, setBarOptions] = useState(initBarOptions(0, []));
    const [barSeries, setBarSeries] = useState(initBarSeries([]));
    const [relatedCategories, setRelatedCategories] = useState([]);
    const [totalLeads, setTotalLeads] = useState();
    // const [baseURL, setBaseUrl] = useState();
    const [imageName, setImageName] = useState('');
    const [active, setActive] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [categoryGroupsData, setCategoryGroupsData] = useState({ categoryGroups: [], grandTotal: 0 })
    const [displayCategoryGroups, setdisplayCategoryGroups] = useState({ categoryGroups: [], grandTotal: 0 })
    const [countryName, setCountryName] = useState('');
    const [metaKeywords, setMetaKeywords] = useState('');
    const [ogImage, setOgImage] = useState(`${process.env.REACT_APP_URL}${defaultImage}`);

    // const baseURL = 'https://wow-leads.netlify.app/images/';
    const baseURL = 'https://wowcatgories.netlify.app/images/';

    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const categoryName = searchParams.get("category")?.trim();
    let categoryGroup = searchParams.get("categorygroup")?.trim();
    let country = searchParams.get("country")?.toLowerCase().trim();
    country = country==='us'? 'US': (country==='in'? 'IN':'');
    const planid = plan?.plan?.id;


    useEffect(() => {
        const fetchMetaData = async () =>{
          try{
                const response = await axios.post('/getmetadata',{
                    'category': categoryGroup ? categoryGroup : (categoryName ? categoryName:null),
                    'isCategory': categoryGroup ? 0 : (categoryName ? 1: null)
                });
                setMetaKeywords(response.data.metakeywords);

                const img = new Image();
                img.src = categoryImageUrl(baseURL, categoryName);
                img.onload = () =>  setOgImage(categoryImageUrl(baseURL, categoryName)); 
                img.onerror = () => setOgImage(`${process.env.REACT_APP_URL}${defaultImage}`);
          }
          catch(err){
            console.log(err);
            setOgImage(`${process.env.REACT_APP_URL}${defaultImage}`);
          } 
        }

        const fetchData = async () => {
            let response;
            let relatedcategories;
            let imgname;


            try {
                setCountryName(country)
                if(categoryGroup){
                  response = await axios.get(`/categorygroupdetails?categorygroup=${categoryGroup??''}&country=${country??''}`);
                  relatedcategories = Array.isArray(response.data.categories)? response.data.categories:mergeRelatedCategories(response.data.categories);
                  imgname = relatedcategories[0]?.relatedcategory;
                }else{
                  response = await axios.get(`/categorydetails?category=${categoryName??''}&country=${country??''}`);
                  relatedcategories = Array.isArray(response.data.relatedcategories)? response.data.relatedcategories:(Object.keys(response.data.relatedcategories).length === 0 ? '':mergeRelatedCategories(response.data.relatedcategories));
                  imgname = response.data.result[0]?.category;
                }

                let result = response.data.result;
                result = result.length > 1 ? mergeResults(result) : (result.length===0? {}:result[0]);
                
                const top10states = response.data.states;
                const totalleads = response.data.totalleads[0].count;
                const chunkedRelateCategories = chunkArray(relatedcategories, 5);

                let socialCount = Object.keys(result).length  > 0 ? parseInt(result.facebookurlcount) +
                    parseInt(result.twitterurlcount) +
                    parseInt(result.linkedinurlcount) +
                    parseInt(result.instagramurlcount) +
                    parseInt(result.youtubeurlcount) +
                    parseInt(result.pinteresturlcount) : 0
                result.socialcount = socialCount;
                
                setImageName(imgname);
                setTotalLeads(totalleads);
                setCategoryDetails(result);

                setSiteOptions(initBarOptions(10, ['Contact Forms', 'Forms w/o Captcha', 'Contact Page', 'About Page', 'Team Page', 'Careers Page', 'Inverstor Page', 'Product Page', 'Shopping Cart', 'Mobile App']));
                setSiteSeries(initBarSeries(Object.keys(result).length ?[
                    result.contactformcount,
                    result.contactformnccount,
                    result.contacturlcount,
                    result.abouturlcount,
                    result.leadershipurlcount,
                    result.careersurlcount,
                    result.investorurlcount,
                    result.producturlcount,
                    result.carturlcount,
                    result.mobileappscount
                ]:[]));


                setSocialOptions(initBarOptions(20, ['Facebook', 'X/Twitter', 'Instagram', 'LinkedIn', 'YouTube', 'Pinterest', 'WhatsApp']));
                setSocialSeries(initBarSeries(Object.keys(result).length ?[
                    result.facebookurlcount,
                    result.twitterurlcount,
                    result.instagramurlcount,
                    result.linkedinurlcount,
                    result.youtubeurlcount,
                    result.pinteresturlcount,
                    result.whatsappurlcount
                ]:[]));

                setTreemapOptions(initTreemapOptions([]));
                setTreemapSeries(top10states.length>0 ? initTreemapSeries(top10states):[]);

                setBarOptions(initBarOptions(0, ['Businesses', 'Branches', 'Addresses', 'Phone Numbers', 'Websites', 'Emails', 'People']));
                setBarSeries(initBarSeries(Object.keys(result).length?[
                    result.total_leads,
                    result.branches,
                    result.addresses,
                    result.phone_numbers,
                    result.websites,
                    result.emails,
                    result.people,
                ]:[]));

                setRelatedCategories(chunkedRelateCategories);

                // Fetch categorygroups
                const categoryGroupsResponse = await axios.get(`/getcategorygroups?country=${country}`);
                const categoryGroups = categoryGroupsResponse.data
                const totalLeads = categoryGroups.reduce((sum, row) => sum + parseInt(row.count), 0)
                setCategoryGroupsData({ categoryGroups: categoryGroups, grandTotal: totalLeads });
                setdisplayCategoryGroups({ categoryGroups: categoryGroups, grandTotal: totalLeads });


                // refresh AOS after dynamic data is rendered so animations trigger correctly
                if (window.AOS && typeof window.AOS.refresh === 'function') window.AOS.refresh();

            } catch (error) {
                console.log("Error occurs during getting categorydetails: ", error);
            }
        }

        fetchMetaData();

         if(window.AOS){
            window.AOS.init({
                duration: 800,
                easing: 'ease-in-out',
                mirror: false,
                offset: 120
            });
        }
        fetchData();
    }, []);



    function initBarOptions(chartMode, data) {
        return {
            tooltip: {
                enabled: true,
                y: {
                    formatter: function (val, opt) {
                        return (val > 0) ? val.toLocaleString() : ''
                    }
                },
            },
            plotOptions: {
                bar: {
                    barHeight: '90%',
                    distributed: true,
                    horizontal: true,
                    borderRadius: 0,
                    dataLabels: { position: 'bottom' }
                }
            },
            colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e', '#f48024', '#69d2e7', '#8024f4', '#d2e769'],
            dataLabels: {
                enabled: true,
                enabledOnSeries: true,
                textAnchor: 'start',
                offsetX: 10,
                offsetY: 0,
                style: { colors: ['#000'] },
                formatter: function (val, opt) {
                    return (val > 0) ? val.toLocaleString() : ''
                },
                dropShadow: { enabled: false, color: '#fff' }
            },
            xaxis: {
                categories: data ? data : [],
                labels: {
                    trim: true,
                    formatter: function (value) {
                        let result = parseInt(value);
                        if (value >= 1000000) {
                            result = `${value / 1000000}M`
                        } else if (value >= 1000) {
                            result = `${value / 1000}K`
                        }
                        return result;
                    }
                }
            },
            yaxis: {
                labels: { show: true }
            },
            legend: {
                show: false,
                position: 'bottom'
            },
            chart: {
                toolbar: { show: false },
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 900,
                    animateGradually: { enabled: true, delay: 80 },
                    dynamicAnimation: { enabled: true, speed: 300 }
                }
            }
        }
    }

    function initTreemapOptions(data) {
        return {
            chart: {
                type: 'treemap',
                toolbar: {
                    show: false,
                },
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 1000
                },
                events: {
                    // click: function (event, chartContext, config) {
                    //     const dataPointIndex = config.dataPointIndex;
                    //     const seriesIndex = config.seriesIndex;
                    //     if (dataPointIndex !== -1) {
                    //         const data = config.config.series[seriesIndex].data[dataPointIndex];
                    //         passPieFilter(data?.x);
                    //     }
                    // },
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (text, op) {
                    let result = op.value;
                    return [text, shrinkNumber(result)]
                },
            },
            plotOptions: {
                treemap: {
                    distributed: true,
                    enableShades: false,
                    dataLabels: {
                        format: "scale",
                    },
                }
            },
            tooltip: {
                enabled: true,
            },
        }
    }

    function initBarSeries(data) {
        return [{
            name: "Category",
            data: data ? data : []
        }]
    }

    function initTreemapSeries(data) {
        const treeMapData = data?.map(row => ({
            x: row.state,
            y: row.total_leads
        }))
        return [{
            data: treeMapData ? treeMapData : []
        }]
    }

    const shrinkNumber = (value) => {
        let result = value;
        if (parseFloat(result) >= 1000000) {
            result = `${Math.floor(result / 1000000)}M`
        } else if (parseFloat(result) >= 1000) {
            result = `${Math.floor(result / 1000)}K`
        } else {
            result = result.toLocaleString()
        }
        return result
    }

    const categoryImageUrl = (baseUrl, categoryName) => {
        if (!categoryName) return "";
        let fileName = categoryName.trim().toLowerCase();
        fileName = fileName.replace(/&/g, "n");
        fileName = fileName.replace(/\//g, "or");
        fileName = fileName.replace(/\s+/g, "_");
        fileName += ".webp";
        return `${baseUrl}${fileName}`;
    }

    const chunkArray = (arr, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i + chunkSize) {
            chunks.push(arr.slice(i, i += chunkSize))
        }
        return chunks;
    };

    const formatNumber = ((num) => {
        const number = parseInt(num);
        return (isNaN(number) ? '' : number.toLocaleString());
    });

    const mergeResults=((results)=>{
        const us_result = results[0];
        const in_result = results[1];
        const result = Object.keys(in_result).reduce((sum, key) => {
            if(key==='category'|| key==='categorygroup')
                sum[key]=in_result[key];
            else
                sum[key] = parseInt(in_result[key]) + parseInt(us_result[key]);
            return sum;
        }, {});
        return result
    })

   const mergeRelatedCategories=((relatedcategories)=>{

            const {baserelatedcategories,countriesdata}=relatedcategories

            let result=baserelatedcategories.map(rc=>{
                let rccount=0
                countriesdata.map(countrydata=>{
                    const rcategory=countrydata.find(row=>row.relatedcategory.toLowerCase()===rc.toLowerCase())  
                    if(rcategory)
                        rccount+=parseInt(rcategory?.count)
                })

                return {relatedcategory:rc,count:rccount}
            })

            result=result?.filter(c=>c.count>0)
            result = result.sort((a,b)=>b.count-a.count)
            return result
    })

    const handleSearch= (query)=>{
       if(query.length<=3){
          setdisplayCategoryGroups(categoryGroupsData);
       }else{
  
           const filterData = categoryGroupsData.categoryGroups.map((group)=>{
                const categorygroup = group.categorygroup.toLowerCase().trim()
                const isGroupMatch = categorygroup.includes(query.toLowerCase().trim())
                
                if(isGroupMatch){
                    return group
                }else{
                    const matchSubcategories = group.subcategories?.filter((sc)=> {
                                const subcategory = sc.category?.toLowerCase().trim();
                                return subcategory?.includes(query.toLowerCase().trim())
                        })
                
                    if(matchSubcategories.length>0){
                            return {...group, subcategories:matchSubcategories};
                    }
                }
            }).filter(Boolean)
        
            const totalLeads = filterData.reduce((sum, row) => sum + parseInt(row.count), 0)      
            setdisplayCategoryGroups({ categoryGroups: filterData, grandTotal: totalLeads })
            }       
  }

  const handleChange = (e) => {
        const value = e.target.value
        setSearchQuery(value)
        handleSearch(value);
    }

  const handleSelect = async(country)=>{
         setCountryName(country);
         const categoryGroupsResponse = await axios.get(`/getcategorygroups?country=${country}`);
         const categoryGroups = categoryGroupsResponse.data
         const totalLeads = categoryGroups.reduce((sum, row) => sum + parseInt(row.count), 0)
         setCategoryGroupsData({ categoryGroups: categoryGroups, grandTotal: totalLeads });
         setdisplayCategoryGroups({ categoryGroups: categoryGroups, grandTotal: totalLeads })
   }

    return (<>
        <Helmet>
            <title>{(categoryName || categoryGroup) ? `Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''} | ${categoryGroup ? categoryGroup : categoryName}`:`Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''}`}</title>
            <meta name="description" content={(categoryName || categoryGroup) ? `Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''} | ${categoryGroup ? categoryGroup : categoryName}`:`Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''}`}></meta>
            <meta name="keywords" content={metaKeywords}></meta>
            <link rel="canonical" href={`${process.env.REACT_APP_URL}/catalogsummary`} />
            <meta property="og:title" content={(categoryName || categoryGroup) ? `Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''} | ${categoryGroup ? categoryGroup : categoryName}`:`Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''}`}></meta>
            <meta property="og:description" content={(categoryName || categoryGroup) ? `Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''} | ${categoryGroup ? categoryGroup : categoryName}`:`Wowleads B2B Database List ${countryName ? `| ${countryName.toUpperCase()}` : ''}`}></meta>
            <meta property="og:url" content={`${process.env.REACT_APP_URL}/catalogsummary`}></meta>
            <meta property="og:image" content={ogImage}></meta>
        </Helmet>

        <div className="landing-page-main">
            <div>
                <section id="hero" class="hero section">
                    <img src={categoryImageUrl(baseURL, imageName)} onError={(e)=>{e.target.src=defaultImage}} alt="" data-aos="zoom-out" data-aos-duration="3000"/>
                    <div class="container">
                        <div class="row mx-1">
                            <div class="col-lg-6 px-3 py-3 my-auto glass-effect">
                                <h2 class="mb-2 fs-fluid-1">Want more customers?</h2>
                                <div class="typewriter-js">
                                    <Typewriter
                                        options={{
                                            strings: [
                                                "☞ Reach your total addressable market.",
                                                "☞ Unlock a treasure full of prospects."
                                            ],
                                            autoStart: true,
                                            loop: true,
                                        }}
                                    />
                                </div>
                            </div>
                            <div class="col-lg-1">&nbsp;</div>
                            <div class="col-lg-5 col-md-6 px-3 py-3 glass-effect">
                                {categoryName || categoryGroup ?
                                    (<div>
                                        <h4 class="" data-aos="fade-up" data-aos-delay="100">Business Category:</h4>
                                        <h2 class="mt-2" data-aos="fade-up" data-aos-delay="200">{categoryGroup ? (categoryDetails.categorygroup??''): (categoryDetails.category??'')}</h2>
                                        <hr />
                                    </div>)
                                    : ''}
                                <h3 class="mt-4" data-aos="fade-up" data-aos-delay="100">B2B Database List {countryName ? `| ${countryName.toUpperCase()}` : ''} </h3>
                                <h3 class="mt-4" data-aos="fade-up" data-aos-delay="200">{formatNumber(categoryDetails.total_leads)} Businesses</h3>
                                <hr />
                                <h6 class="mt-4" data-aos="fade-up" data-aos-delay="200"><a href="#category-group">Select from 4,500+ business categories <i class="bi bi-arrow-right-circle"></i></a></h6>
                                {totalLeads? <h6 class="mt-2" data-aos="fade-up" data-aos-delay="200">{shrinkNumber(parseInt(totalLeads))}+ Businesses</h6>:''}
                                {planid === 3 || planid === 1 ? '' :
                                    <div class="d-flex mt-5" data-aos="fade-up" data-aos-delay="400">
                                        {!planid || planid === 7 ?
                                            <a href="/signup" class="btn-get-started text-center">FREE SIGNUP<br /><small>No Credit Card</small></a>
                                            : <a href="/pricing" class="btn-get-started text-center">UPGRADE<br /><small>To Premium Plan</small></a>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>


                <section id="stats" class="stats section">

                    <div class="container">

                        <div class="row gy-4">

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-headset"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.branches)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>Branches</p>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-geo-alt"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.addresses)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>Addresses</p>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-globe"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.websites)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>Websites</p>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-layout-text-window-reverse"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.contactformcount)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>Contact Forms</p>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-telephone"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.phone_numbers)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>Phones</p>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-envelope"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.emails)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>Emails</p>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-chat-dots"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.socialcount)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>Social</p>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                                <i class="bi bi-people"></i>
                                <div class="stats-item">
                                    <CountUp start={0} end={parseInt(categoryDetails.people)} separator="," delay={0} duration={1} enableScrollSpy redraw={true}/>
                                    <p>People</p>
                                </div>
                            </div>

                        </div>

                    </div>

                </section>

                <section id="services" class="services section section-bg dark-background">

                    <div class="container section-title" data-aos="fade-up">
                        <h2>Data + Outreach on the same Platform</h2>
                        <p>Relying only on customer referrals or advertising limits growth. Proactive lead generation and bulk prospect outreach creates a steady pipeline, expands visibility, and taps into new markets. This approach drives predictable growth and reduces dependency on chance opportunities.</p>
                    </div>

                    <div class="container">

                        <div class="row gy-4">

                            <div class="col-md-6" data-aos="fade-right" data-aos-delay="100">
                                <div class="service-item d-flex position-relative h-100">
                                    <i class="bi bi-headset icon flex-shrink-0"></i>
                                    <div>
                                        <h4 class="subtitle mb-3">{formatNumber(categoryDetails?.phone_numbers)} Phone Numbers</h4>
                                        <h4 class="title">Cold Calling/Telemarketing</h4>
                                        <p class="description">Engage prospects directly, build personal connections, and address objections in real time, creating immediate opportunities and stronger trust compared to passive marketing methods.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6" data-aos="fade-left" data-aos-delay="100">
                                <div class="service-item d-flex position-relative h-100">
                                    <i class="bi bi-robot icon flex-shrink-0"></i>
                                    <div>
                                        <h4 class="subtitle mb-3">{formatNumber(categoryDetails?.phone_numbers)} Phone Numbers</h4>
                                        <h4 class="title">Agentic AI Outbound Voice Bot</h4>
                                        <p class="description">Automate personalized prospect calls at scale, handle objections intelligently, qualify leads instantly, and schedule appointments — delivering human-like engagement with unmatched efficiency, consistency, and cost savings.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6" data-aos="fade-right" data-aos-delay="100">
                                <div class="service-item d-flex position-relative h-100">
                                    <i class="bi bi-envelope icon flex-shrink-0"></i>
                                    <div>
                                        <h4 class="subtitle mb-3">{formatNumber(categoryDetails?.emails)} Email IDs</h4>
                                        <h4 class="title">Email Marketing</h4>
                                        <p class="description">Deliver targeted, scalable messages to decision-makers, nurture relationships over time, and measure responses easily to refine campaigns and maximize ROI.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6" data-aos="fade-left" data-aos-delay="100">
                                <div class="service-item d-flex position-relative h-100">
                                    <i class="bi bi-mailbox icon flex-shrink-0"></i>
                                    <div>
                                        <h4 class="subtitle mb-3">{formatNumber(categoryDetails?.addresses)} Addresses</h4>
                                        <h4 class="title">Direct Mail</h4>
                                        <p class="description">Stand out with tangible, personalized communication that captures attention, builds credibility, and differentiates your outreach in today’s digital-heavy landscape.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6" data-aos="fade-right" data-aos-delay="100">
                                <div class="service-item d-flex position-relative h-100">
                                    <i class="bi bi-layout-text-window-reverse icon flex-shrink-0"></i>
                                    <div>
                                        <h4 class="subtitle mb-3">{formatNumber(categoryDetails?.contactformcount)} Contact Forms</h4>
                                        <h4 class="title">Contact Form Submittals</h4>
                                        <p class="description">Reach prospects on their own websites by submitting inquiries directly, ensuring visibility, faster responses, and positioning your business as a relevant vendor or partner.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6" data-aos="fade-left" data-aos-delay="100">
                                <div class="service-item d-flex position-relative h-100">
                                    <i class="bi bi-chat-dots icon flex-shrink-0"></i>
                                    <div>
                                        <h4 class="subtitle mb-3">{formatNumber(categoryDetails?.socialcount)} Social Media Accounts</h4>
                                        <h4 class="title">Direct Messaging</h4>
                                        <p class="description">Send personalized, targeted messages on social platforms, sparking conversations, building relationships, and moving prospects toward meaningful engagement quickly and efficiently.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                <Row className="px-3 py-5 justify-content-around fw-bold align-items-center mb-5" data-aos="fade-up">
                    <Col md={4} data-aos="fade-up" data-aos-duration="700">
                        <div id="sitestats" title="Web Site Stats">
                            <h3 className="my-md-4 my-2 fw-bold text-center">Web Site Stats</h3>
                            <div data-aos="fade-up" data-aos-duration="900" data-aos-delay="120">
                                <Chart
                                    type='bar'
                                    options={siteOptions}
                                    series={siteSeries}
                                />
                            </div>
                        </div>
                    </Col>

                    <Col md={4} data-aos="fade-up" data-aos-delay="160">
                        <div id="socialpresence" title="Social Presence">
                            <h3 className="my-md-4 my-2 fw-bold text-center">Social Media Presence</h3>
                            <div data-aos="fade-up" data-aos-duration="900" data-aos-delay="240">
                                <Chart
                                    type='bar'
                                    options={socialOptions}
                                    series={socialSeries}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>

                {treemapSeries.length>0 &&
                (<Row className="justify-content-center mb-4" data-aos="zoom-in">
                    <Col md={5}>
                        <h3 className="text-center pb-4 fw-bold">Top 10 States</h3>
                        <div id="top10" title="States">
                            <div data-aos="zoom-in" data-aos-duration="900" data-aos-delay="120">
                                <Chart
                                    type='treemap'
                                    options={treemapOptions}
                                    series={treemapSeries} />
                            </div>
                        </div>
                    </Col>
                </Row>)}

               {relatedCategories.length>0 && (
                <section className="section-bg" data-aos="fade-up">
                    <Container className="section-title mx-auto">
                        <h2>
                            {categoryGroup ? ``:`Other Related Industries and `}Business Categories
                        </h2>

                        <div className="d-flex overflow-auto related">
                            {relatedCategories.map((displayGroup, groupIndex) => (
                                <div key={groupIndex} className="mt-5 col-md-4 gap-3 col-6 p-3 related-links">
                                    {displayGroup?.map((row, rowIndex) => (
                                        <a
                                            key={rowIndex}
                                            href={`/catalogsummary?category=${row.relatedcategory}&country=${country??''}`}>
                                            <div className="d-flex justify-content-between"><span>{row.relatedcategory}&nbsp; &nbsp;({parseInt(row.count).toLocaleString()})</span></div>
                                        </a>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </Container>
                </section>)
                }


                <section id="category-group" class="tam" data-aos="fade-up">
                    <div class="container header">
                        <div class="row text-center">
                            <h3>Determine your</h3>
                            <h2 class="tam-title">Total Addressable Market (TAM)</h2>
                            <h3>across 4,500+ Industries & Business Categories</h3>
                            {planid === 3 || planid === 1 ? '' :
                                <div class="my-3 text-center">
                                    {!planid || planid === 7 ?
                                        <a href="/signup" class="btn-get-started text-center">FREE SIGNUP<br /><small>No Credit Card</small></a>
                                        : <a href="/pricing" class="btn-get-started text-center">UPGRADE<br /><small>To Premium Plan</small></a>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </section>

                <section className="categorygroup">
                    <Row className="col-md-10 col-lg-10 col-xl-10 col-12 mx-auto px-md-4 px-lg-4 px-xl-4 px-2 text-center justify-content-center fs-6" data-aos="fade-up">
                        <Card className="mb-3 border-0 col-md-10">
                                <Card.Header className="bg-primary text-white fw-bold py-3 position-relative header">
                                    <Row>
                                        <Col md={5} className="text-start searchbar">
                                            <input type="text" placeholder="Search...." value={searchQuery} onChange={handleChange}/>
                                            <span onClick={()=>handleSearch(searchQuery)}><i class="bi bi-search"></i></span>
                                        </Col>
                                        <Col md={5} className="text-md-start text-center"><h6 className="header-text fw-bold">Business Category Groups</h6></Col>
                                        <Col md={2} className="text-end">
                                            <div>
                                                <Form.Select value={countryName} onChange={(e) => handleSelect(e.target.value)} className="country-selector">
                                                    <option value="US">US</option>
                                                    <option value="IN">IN</option>
                                                    <option value="">All</option>
                                                </Form.Select>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                
                                <Card.Body style={{ padding: 0 }}>
                                    <Row className="bg-light mx-1 fw-bold shadow" style={{ padding: '10px 15px' }}>
                                        <Col md={4} xs={4} className="text-start">Category Group</Col>
                                        <Col md={4} xs={4}>Category</Col>
                                        <Col md={4} xs={4} className="text-end">Count</Col>
                                    </Row>
                
                                    <Accordion activeKey={active}>
                                        {displayCategoryGroups?.categoryGroups?.map((g,idx)=>(
                                            <Accordion.Item eventKey={String(idx)} key={idx}>
            
                                                <Accordion.Header onClick={() => setActive(active === String(idx) ? null : String(idx))}>
                                                    <Row className="position:sticky" style={{ width: '100%', fontSize: "clamp(0.8rem, 1vw, 1.6rem)"}}>
                                                        <Col md={9} xs={7} className="fw-semibold px-4 text-muted"><a href={`/catalogsummary?categorygroup=${g.categorygroup??''}&country=${country??''}`}>{g.categorygroup ?? ''}</a></Col>
                                                        <Col md={3} xs={5} className="fw-bold text-end text-muted">{formatNumber(g.count)}</Col>
                                                    </Row>
                                                </Accordion.Header>
            
                                                <Accordion.Body  className="p-0 p-md-2 p-lg-2">
                                                    {g.subcategories && g.subcategories.length ? (
                                                        <div className="overflow-y-auto overflow-x-hidden" style={{ maxHeight: "300px" ,fontSize: "clamp(0.8rem, 1vw, 1.6rem)" }}>
                                                            {g.subcategories.map((c, i) => (
                                                                parseInt(c.leads_count) >10 ? (
                                                                    <Row key={i} style={{ padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                                    <Col md={5} xs={5}></Col>
                                                                    <Col md={4} xs={4} className="text-start fw-semibold"><a href={`/catalogsummary?category=${c.category??''}&country=${country??''}`}>{c.category ?? ''}</a></Col>
                                                                    <Col md={3} xs={3} className="fw-semibold" style={{ textAlign: 'right', paddingRight: '25px' }}>{formatNumber(c.leads_count)}</Col>
                                                                </Row>
                                                                ):''))
                                                            }
                                                        </div>
                                                        ) : (<div style={{ color: '#666' }}>No categories available for this group.</div>)
                                                    }
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>

                                    <div className="d-flex justify-content-between bg-light  border-4 border-primary border-top fw-bold">
                                        <p className="px-4 py-1">Grand Total</p>
                                        <p className="pe-4 py-1">{formatNumber(displayCategoryGroups.grandTotal)}</p>
                                    </div>
                                </Card.Body>
                        </Card>
                    </Row>
                </section>
            </div>
        </div>
    </>)
}
export default CategoryLandingPage;